import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDimensionEngagementAmbassador state domain
 */

const selectWidgetResultByDimensionEngagementAmbassadorDomain = (state) =>
  state.get("widgetResultByDimensionEngagementAmbassador", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDimensions = () =>
  createSelector(
    selectWidgetResultByDimensionEngagementAmbassadorDomain,
    (state) => state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(
    selectWidgetResultByDimensionEngagementAmbassadorDomain,
    (state) => state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(
    selectWidgetResultByDimensionEngagementAmbassadorDomain,
    (state) => state.get("divisions")
  )
export const makeSelectShowDimensionBenchmark = () =>
  createSelector(
    selectWidgetResultByDimensionEngagementAmbassadorDomain,
    (state) => state.get("showDimensionBenchmark")
  )

/**
 * Default selector used by WidgetResultByDimensionEngagementAmbassador
 */

const makeSelectWidgetResultByDimensionEngagementAmbassador = () =>
  createSelector(
    selectWidgetResultByDimensionEngagementAmbassadorDomain,
    (substate) => substate.toJS()
  )

export default makeSelectWidgetResultByDimensionEngagementAmbassador
export { selectWidgetResultByDimensionEngagementAmbassadorDomain }
